import { render, staticRenderFns } from "./SortOneManyForm.vue?vue&type=template&id=6b9b39e0&scoped=true&lang=pug&"
import script from "./SortOneManyForm.vue?vue&type=script&lang=js&"
export * from "./SortOneManyForm.vue?vue&type=script&lang=js&"
import style0 from "./SortOneManyForm.vue?vue&type=style&index=0&id=6b9b39e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b39e0",
  null
  
)

export default component.exports